@if (trainingRoom) {
	@if (styling === "default" || styling === "live-view") {
		<div class="{{ styling }}">
			<div class="roomLayoutSwitchButtons">
				@for (_ of [].constructor(RoomLayoutSwitcherComponent.maxAmountLayouts); track $index; let i = $index) {
					<div
						[class.active]="selectedPreset === i"
						[class.disabled]="!trainingRoom?.roomLayout?.[i] || !!disabled"
						(click)="setSelectedPreset(i)"
						matRipple
						class="roomLayoutSwitchButton"
						matTooltip="{{ getPresetName(trainingRoom?.roomLayout, i, true) }}"
						matTooltipClass="accent"
					>
						{{ i + 1 }}
						@if (loadingRoomChange && i === nextPreset) {
							<div class="loadingRoomChange">
								<i class="fad fa-spinner-third fa-spin"></i>
							</div>
						}
					</div>
				}
			</div>
		</div>
	}
	@if (styling === "room-detail") {
		<div class="{{ styling }}">
			<div class="roomLayoutSwitcher">
				<div class="roomLayoutSwitchButtons">
					@for (_ of [].constructor(RoomLayoutSwitcherComponent.maxAmountLayouts); track $index; let i = $index) {
						<button
							[class.active]="selectedPreset === i"
							[disabled]="!trainingRoom?.roomLayout?.[i] || !!disabled"
							(click)="setSelectedPreset(i)"
							mat-mini-fab
							class="roomLayoutSwitchButton"
							color="accent"
							matTooltip="{{ getPresetName(trainingRoom?.roomLayout, i, true) }}"
							matTooltipClass="accent"
						>
							{{ i + 1 }}
						</button>
					}
				</div>
			</div>
		</div>
	}
}
